/** Flow link redirects mounted by App.tsx (`/flows/:flowId`, `/flows`). */
import { Navigate, useParams, useSearchParams } from "react-router";
import { PageSpinner } from "@/components/ui";
import { flowEditorPath } from "@/lib/flows";
import { brandPath, lastBrand, useBrands } from "@/state/brand";

/**
 * Short flow link `/flows/:flowId` (server cards / shared links): brand from `?brand=`, else the last-used brand the
 * user can still see, else their first brand → canonical `/b/:brandId/flows/:flowId` (other query params kept).
 */
export function FlowShortRedirect() {
  const { flowId } = useParams();
  const [sp] = useSearchParams();
  const { brands, isLoading } = useBrands();
  if (!flowId) return <Navigate to="/" replace />;
  const rest = new URLSearchParams(sp);
  rest.delete("brand");
  const qs = rest.toString() ? `?${rest.toString()}` : "";
  const requested = sp.get("brand");
  if (requested) return <Navigate to={`${flowEditorPath(requested, flowId)}${qs}`} replace />;
  if (isLoading) return <PageSpinner />;
  const last = lastBrand();
  const brandId = last && brands.some((b) => b.id === last) ? last : (brands[0]?.id ?? last);
  if (!brandId) return <Navigate to="/brands" replace />;
  return <Navigate to={`${flowEditorPath(brandId, flowId)}${qs}`} replace />;
}

/** `/flows` → the current brand's Flows list. */
export function FlowsIndexRedirect() {
  const { brands, isLoading } = useBrands();
  if (isLoading) return <PageSpinner />;
  const last = lastBrand();
  const brandId = last && brands.some((b) => b.id === last) ? last : brands[0]?.id;
  return <Navigate to={brandId ? brandPath(brandId, "flows") : "/brands"} replace />;
}
